const LINK_KEY_RE = /^[A-Za-z0-9_-]{16,64}$/
const LINK_KEY_STORE = 'oc_k:'

/**
 * รหัสลับในลิงก์ออร์เดอร์ (&k=) — กันคนนอกเดาเลขออร์เดอร์ (คู่กับ CF ordercus/orderLinkKey.js)
 * อ่านจาก ?k= ตรง หรือใน liff.state (ลิงก์ liff.line.me) · จำต่อออร์เดอร์ใน localStorage
 * เพราะ LIFF login / รีเฟรช / ลบ query ทีหลังอาจทำให้ k หายจาก URL
 */
export function resolveOrderLinkKey(orderId: string, href = window.location.href): string {
  let key = ''
  try {
    const url = new URL(href, 'https://order.srikanett.com')
    key = url.searchParams.get('k') || ''
    if (!key) {
      let state = url.searchParams.get('liff.state') || ''
      for (let attempt = 0; attempt < 2 && /%3[fd]|%26/i.test(state); attempt += 1) state = decodeURIComponent(state)
      if (state.startsWith('?')) state = state.slice(1)
      key = new URLSearchParams(state).get('k') || ''
    }
  } catch {
    /* ignore */
  }
  const storeKey = LINK_KEY_STORE + String(orderId || '').trim()
  try {
    if (LINK_KEY_RE.test(key)) {
      localStorage.setItem(storeKey, key)
      return key
    }
    const saved = localStorage.getItem(storeKey) || ''
    return LINK_KEY_RE.test(saved) ? saved : ''
  } catch {
    return LINK_KEY_RE.test(key) ? key : ''
  }
}

/**
 * ปิดบังเบอร์โทรสำหรับคนที่เปิดแบบแขก (ลิงก์ที่ถูกส่งต่อ) หลังยืนยันออร์เดอร์แล้ว — ซ่อน 3 ตัวท้าย
 * ตอนกรอก/แก้ข้อมูลยังเห็นเต็ม (ลูกค้า Facebook ไม่มี LINE จึงเป็นแขกเสมอ)
 */
export function maskPhone(phone: string): string {
  const s = String(phone || '').trim()
  const digits = s.replace(/\D/g, '')
  if (digits.length < 6) return s ? 'xxx' : ''
  // เห็นเลขนำหน้า ซ่อน 3 ตัวท้าย เช่น 0992966xxx
  return `${digits.slice(0, -3)}xxx`
}

/** ปิดบังปีเกิด — เหลือ 2 หลักแรกของปี พ.ศ. เช่น 14/พฤษภาคม/2536 → 14/พฤษภาคม/25XX */
export function maskBirthdayYear(text: string): string {
  return String(text || '').replace(/(\d{2})\d{2}(?!\d)/g, '$1XX')
}
